import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { green, grey, white } from './colors';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

/** For use strictly within @chronosphereio/chrono-ui */
const switchTokens = [
  { propertyPath: 'thumbCheckedColor', tokenName: '--semantic-bg-input-default' },
  { propertyPath: 'thumbDisabledColor', tokenName: '--semantic-bg-input-disabled' },
  { propertyPath: 'thumbUncheckedColor', tokenName: '--semantic-bg-input-inverse' },
  { propertyPath: 'trackCheckedColor', tokenName: '--semantic-bg-input-inverse' },
  { propertyPath: 'trackCheckedHoverColor', tokenName: '--semantic-bg-input-inverse-hover' },
  { propertyPath: 'trackHoverColor', tokenName: '--semantic-bg-interactive-neutral-hover' },
  { propertyPath: 'trackUncheckedColor', tokenName: '--semantic-bg-input-default' },
] satisfies Token[];

export const switchTokenMetadata: PaletteTokenMetadata = {
  componentName: 'switch',
  tokens: switchTokens,
};

export const switchPalette = (mode: PaletteMode, opts: GetThemeOptions): NonNullable<PaletteOptions['switch']> => {
  if (opts.panwRebrandStubYear) {
    const semanticTokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(switchTokenMetadata.tokens, semanticTokens, xcorTokens);
  }

  return mode === 'light'
    ? {
        trackCheckedColor: green[600],
        trackUncheckedColor: grey[400],
        thumbColor: white,
        thumbDisabledColor: grey[100],
        thumbUncheckedColor: white,
        // we don't actually use these in the legacy world
        thumbCheckedColor: white,
        trackCheckedHoverColor: white,
      }
    : {
        trackCheckedColor: green[600],
        trackUncheckedColor: grey[600],
        thumbColor: white,
        thumbDisabledColor: grey[700],
        thumbUncheckedColor: white,
        // we don't actually use these in the legacy world
        thumbCheckedColor: white,
        trackCheckedHoverColor: white,
      };
};
